import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { initAuth, login, configureStoreAuth } from "./utils/auth";
import "./index.css";

// Initialize authentication before rendering the app
const authenticated = initAuth();

if (authenticated) {
  // Configure the sprout-store with the JWT token
  configureStoreAuth();
} else {
  // Redirect to Cognito Hosted UI for federated login
  login();
}

// Render app (will show loading state while redirecting)
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
